import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'gymfinder-geofence-config',
  templateUrl: './geofence-config.component.html',
  styleUrls: ['./geofence-config.component.scss'],
  standalone: false,
})
export class GeofenceConfigComponent {
  @Input() geofence?: number | null;
  @Output() geofenceChange = new EventEmitter<number | null>();

  // If field is emptied, it will be set to null
  onGeofenceChange(value: number | null): void {
    this.geofence = value;
    this.geofenceChange.emit(this.geofence);
  }
}
